module.exports = __webpack_public_path__ + "img/control-panel-disabled.8c26b39b.png";